import { ImageOutlined } from '@mui/icons-material';
import './style.scss';
import { Avatar, Box, Typography } from '@mui/material';


interface IImageProps {
    name?: string;
    src: string;
    onClick?: () => void;
    size?: 'small' | 'medium' | 'large';
    className?: string;
}


const Image: React.FC<IImageProps> = ({
    name = undefined,
    src,
    onClick = () => {},
    size = 'medium',
    className = ''
}) => {
    return <Box className={`image-default ${size} ${className}`} onClick={onClick}>
        <Avatar src={src} alt={name ?? src}>
            <ImageOutlined />
        </Avatar>
        
        {
            name && <Typography className='image-name'>
                {name}
            </Typography>
        }
    </Box>;
}

export default Image;